export default __webpack_public_path__ + "66d41566e21fdab8ba7e3338f1f4d52a.webp";